import styled from "styled-components";

export const Overview = styled.div`
  &&& {
    flex-grow: 1;
    position: relative;
    overflow: auto;

    h1,
    h2,
    h3 {
      margin: 0;
    }

    .page-content {
      padding: 0 7px;
      width: 1214px;
      margin: auto;
      position: relative;
    }

    .table {
      width: 400px;
      margin: 50px auto;
      text-align: center;

      .row {
        padding: 4px 0;
      }

      h2 {
        text-align: left;
        margin-bottom: 28px;
      }
    }

    .table-header,
    .table-footer {
      border-top: solid 1px;
      border-bottom: solid 1px;
      margin-bottom: 4px;

      div {
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        vertical-align: bottom;
        white-space: nowrap;
      }
    }
  }
`;

export const Title = styled.h1`
  &&& {
    text-align: center;
    padding-bottom: 28px;
  }
`;

export const RatingsGraphDetails = styled.div`
  &&& {
    position: absolute;
    z-index: 1;
    top: 32px;
  }
`;

export const VolumeGraphActions = styled.div`
  &&& {
    position: relative;

    button {
      position: absolute;
      top: 32px;
      right: 86px;
      z-index: 1;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Observations/components/ObservationsOverview/style.js